// ************
// Recipe Single View
// Recipe Description
// use text from recipeDetails.rezept_beschreibung
// ************
import { customSanitize } from "@/utils/customSanitize";
import React from "react";
import styles from "./RecipeDescription.module.scss";

function RecipeDescription({ description }: { description: string }) {
  return description ? (
    <section
      className={`${styles["recipe-description"]}`}
      dangerouslySetInnerHTML={{ __html: customSanitize(description) }}
    ></section>
  ) : (
    <></>
  );
}

export default RecipeDescription;
